/**
 * hasObserver - checks if the browser supports IntersectionObserver by checking
 * if it's attached to the window
 *
 * @return boolean indicating if the browser supports IntersectionObserver
 */
export const hasObserver = () => {
    return "IntersectionObserver" in window;
};

/**
 * createObserver - creates and IntersectionObserver, and returns an
 * unobserve callback
 *
 * @param {React Reference} - the react node we want to observe the
 * intersection
 * @param {Function} cb - the callback that handles an intersection
 * @return callback to unobserve
 */
export const createObserver = (target, cb) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.unobserve(target);
                cb();
            }
        });
    });
    observer.observe(target);

    //once unobserved redefine as empty lambda
    let release = () => {
        observer.unobserve(target);
        release = () => {};
    };

    return release;
};

export default createObserver;
